<div class="position-relative">
  <div class="chantier-display user-select-none d-flex align-items-center justify-content-between"
       (click)="onChantierDisplayClicked($event)"
       role="button">
    <span class="chantier-display-text">{{ selectedChantier?.displayName }}</span>
    @if (selectableChantiers.length) {
      <span>
        @if (!showOptions()) {
          <i class="bi bi-caret-down-fill"></i>
        } @else {
          <i class="bi bi-caret-up-fill"></i>
        }
      </span>
    }
  </div>

  @if (showOptions() && selectableChantiers.length) {
    <div class="options position-absolute w-100 start-0"> @for (chantier of selectableChantiers; track chantier.code) {
      <div (click)="onChantierSelected(chantier.code)" class="option" role="button">
        {{ chantier.displayName }}
      </div>
    }
    </div>
  }

</div>
